import * as React from 'react';

import { clsx } from 'clsx';

import * as styles from './SearchBlock.css';

interface ISearchBlockProps {
  backgroundNode: React.ReactNode;
  /**
   * Баннер на всю выделенную область (микрофронтенд ad-banner-frontend).
   * Рисуется отдельным слоем поверх дефолтного фона и под контентом. Сам баннер
   * (фон, пометка «Реклама», оффер, бегущая строка) рендерит микрофронтенд.
   */
  fullAreaBanner?: React.ReactNode;
  isNewFilters: boolean;
  section: string;
  isRedesignEnabled: boolean;
}

export const SearchBlock: React.FC<React.PropsWithChildren<ISearchBlockProps>> = ({
  backgroundNode,
  fullAreaBanner,
  children,
  isNewFilters,
  section,
  isRedesignEnabled,
}) => {
  const isDailyRent = section === 'daily-rent';

  return (
    <div
      data-testid="SearchBlock"
      className={clsx(
        styles['c-filters'],
        isNewFilters && styles['c-filters--new'],
        isDailyRent && styles['c-filters-dailyrent'],
        fullAreaBanner && isRedesignEnabled && styles['c-filters--with-ad'],
      )}
    >
      <div className={styles['c-filters-content']}>
        <div className={clsx(styles['c-filters-inner'])}>{children}</div>
      </div>
      <div className={styles['background']}>{backgroundNode}</div>
      {fullAreaBanner && <div className={styles['full-area-banner']}>{fullAreaBanner}</div>}
    </div>
  );
};
